import { translations } from "../i18n";

const FAQ_CONTENT = {
  en: {
    categories: [
      {
        name: "Product",
        icon: "Package",
        subtitle: "What it is, what is included, and how each model differs.",
        faqs: [
          { q: "What is a SharkX Electric e-foil?", a: "It is an electric foil board designed to lift the rider above the water, combining electric propulsion, precise control, and a setup built for recreational and performance use." },
          { q: "What is included with the purchase?", a: "What is included depends on the model and configuration, but the product page always clarifies the board, battery, charger, remote, and relevant accessories for that setup." }
        ]
      },
      {
        name: "Battery / range",
        icon: "Battery",
        subtitle: "Range, charging, and what actually changes ride time.",
        faqs: [
          { q: "How long does the battery last?", a: "Range depends on the model, rider weight, sea state, riding style, and battery selected. We always confirm the exact number for the chosen configuration on the product sheet." },
          { q: "How long does charging take?", a: "Charging time varies by battery and charger. Check the product sheet or ask support to avoid comparing configurations as if they were identical." }
        ]
      },
      {
        name: "Transport / weight",
        icon: "Weight",
        subtitle: "Total weight, handling, and what changes across configurations.",
        faqs: [
          { q: "How much does the complete setup weigh?", a: "Weight changes with board, battery, and accessories. Product pages should show the weight of the minimum configuration or the selected variant so the number stays clear." },
          { q: "What does 'from 19 kg' mean?", a: "It is the lightest total weight in the range, including the battery, in the minimum configuration. Other combinations may weigh more and should be shown separately." }
        ]
      },
      {
        name: "Warranty",
        icon: "Shield",
        subtitle: "Coverage, documentation, and how to start a claim.",
        faqs: [
          { q: "Which components are covered?", a: "Coverage depends on the model and the policy attached to your purchase, but the Warranty page explains the covered components, claim steps, and exclusions before you submit anything." },
          { q: "Where do I read the full warranty terms?", a: "On the Warranty page and in the purchase documents. If something is unclear, support will confirm the policy that applies to your specific order." }
        ]
      },
      {
        name: "Support / maintenance",
        icon: "Wrench",
        subtitle: "How to reach technical support and what to send to speed up the reply.",
        faqs: [
          { q: "How do I contact support?", a: "Use the support center, the form, or the channel indicated for your case. For urgent ride-day issues, send the serial number, a short summary, and photos or video if possible." },
          { q: "What maintenance does the equipment need?", a: "Routine care is simple: rinse after use, inspect visually, store correctly, and pay attention to parts and batteries. Ask for guidance before attempting repairs on your own." }
        ]
      },
      {
        name: "Payment / delivery",
        icon: "CreditCard",
        subtitle: "Lead times, confirmation, and what to do after ordering.",
        faqs: [
          { q: "How do payment and delivery work?", a: "Lead times and logistics are confirmed after ordering because they depend on configuration, stock, and destination. Always validate your region with the team before purchase." },
          { q: "Do you ship outside Brazil?", a: "Availability depends on the product, destination, and current logistics setup. The contact page or support can confirm the right answer for your order." }
        ]
      }
    ]
  },
  pt: {
    categories: [
      {
        name: "Produto",
        icon: "Package",
        subtitle: "O que é, o que está incluído e como cada modelo difere.",
        faqs: [
          { q: "O que é um e-foil SharkX Electric?", a: "É uma prancha foil elétrica projetada para elevar o piloto acima da água, combinando propulsão elétrica, controle preciso e um setup construído para uso recreativo e de performance." },
          { q: "O que está incluído na compra?", a: "O que está incluído depende do modelo e configuração, mas a página do produto sempre esclarece a prancha, bateria, carregador, controle e acessórios relevantes para aquele setup." }
        ]
      },
      {
        name: "Bateria / autonomia",
        icon: "Battery",
        subtitle: "Autonomia, carregamento e o que realmente muda o tempo de ride.",
        faqs: [
          { q: "Quanto tempo dura a bateria?", a: "A autonomia depende do modelo, peso do piloto, condições do mar, estilo de pilotagem e bateria selecionada. Sempre confirmamos o número exato para a configuração escolhida na ficha do produto." },
          { q: "Quanto tempo leva para carregar?", a: "O tempo de carregamento varia conforme a bateria e o carregador. Consulte a ficha do produto ou peça ao suporte para evitar comparar configurações como se fossem idênticas." }
        ]
      },
      {
        name: "Transporte / peso",
        icon: "Weight",
        subtitle: "Peso total, manuseio e o que muda entre configurações.",
        faqs: [
          { q: "Quanto pesa o setup completo?", a: "O peso varia conforme prancha, bateria e acessórios. As páginas de produto devem mostrar o peso da configuração mínima ou da variante selecionada para que o número fique claro." },
          { q: "O que significa 'a partir de 19 kg'?", a: "É o peso total mais leve da linha, incluindo a bateria, na configuração mínima. Outras combinações podem pesar mais e devem ser mostradas separadamente." }
        ]
      },
      {
        name: "Garantia",
        icon: "Shield",
        subtitle: "Cobertura, documentação e como iniciar uma solicitação.",
        faqs: [
          { q: "Quais componentes são cobertos?", a: "A cobertura depende do modelo e da política vinculada à sua compra, mas a página de Garantia explica os componentes cobertos, passos para solicitação e exclusões antes de você enviar qualquer coisa." },
          { q: "Onde leio os termos completos de garantia?", a: "Na página de Garantia e nos documentos de compra. Se algo não estiver claro, o suporte confirmará a política que se aplica ao seu pedido específico." }
        ]
      },
      {
        name: "Suporte / manutenção",
        icon: "Wrench",
        subtitle: "Como contatar o suporte técnico e o que enviar para agilizar a resposta.",
        faqs: [
          { q: "Como entro em contato com o suporte?", a: "Use o centro de suporte, o formulário ou o canal indicado para o seu caso. Para problemas urgentes no dia do ride, envie o número de série, um resumo breve e fotos ou vídeo se possível." },
          { q: "Que manutenção o equipamento precisa?", a: "Os cuidados de rotina são simples: enxágue após o uso, inspecione visualmente, armazene corretamente e preste atenção às peças e baterias. Peça orientação antes de tentar reparos por conta própria." }
        ]
      },
      {
        name: "Pagamento / entrega",
        icon: "CreditCard",
        subtitle: "Prazos, confirmação e o que fazer após o pedido.",
        faqs: [
          { q: "Como funcionam pagamento e entrega?", a: "Prazos e logística são confirmados após o pedido pois dependem da configuração, estoque e destino. Sempre valide sua região com a equipe antes da compra." },
          { q: "Vocês enviam para fora do Brasil?", a: "A disponibilidade depende do produto, destino e logística atual. A página de contato ou o suporte pode confirmar a resposta correta para o seu pedido." }
        ]
      }
    ]
  },
  es: {
    categories: [
      {
        name: "Producto",
        icon: "Package",
        subtitle: "Qué es, qué está incluido y cómo difiere cada modelo.",
        faqs: [
          { q: "¿Qué es un e-foil SharkX Electric?", a: "Es una tabla foil eléctrica diseñada para elevar al rider sobre el agua, combinando propulsión eléctrica, control preciso y un setup construido para uso recreativo y de rendimiento." },
          { q: "¿Qué está incluido en la compra?", a: "Lo que está incluido depende del modelo y la configuración, pero la página del producto siempre aclara la tabla, batería, cargador, control y accesorios relevantes para ese setup." }
        ]
      },
      {
        name: "Batería / autonomía",
        icon: "Battery",
        subtitle: "Autonomía, carga y qué cambia realmente el tiempo de ride.",
        faqs: [
          { q: "¿Cuánto dura la batería?", a: "La autonomía depende del modelo, peso del rider, estado del mar, estilo de ride y batería seleccionada. Siempre confirmamos el número exacto para la configuración elegida en la ficha del producto." },
          { q: "¿Cuánto tarda la carga?", a: "El tiempo de carga varía según la batería y el cargador. Consultá la ficha del producto o pedí al soporte para evitar comparar configuraciones como si fueran idénticas." }
        ]
      },
      {
        name: "Transporte / peso",
        icon: "Weight",
        subtitle: "Peso total, manejo y qué cambia entre configuraciones.",
        faqs: [
          { q: "¿Cuánto pesa el setup completo?", a: "El peso varía según tabla, batería y accesorios. Las páginas de producto deben mostrar el peso de la configuración mínima o de la variante seleccionada para que el número quede claro." },
          { q: "¿Qué significa 'desde 19 kg'?", a: "Es el peso total más liviano de la gama, incluyendo la batería, en la configuración mínima. Otras combinaciones pueden pesar más y deben mostrarse por separado." }
        ]
      },
      {
        name: "Garantía",
        icon: "Shield",
        subtitle: "Cobertura, documentación y cómo iniciar un reclamo.",
        faqs: [
          { q: "¿Qué componentes están cubiertos?", a: "La cobertura depende del modelo y de la política vinculada a tu compra, pero la página de Garantía explica los componentes cubiertos, pasos para reclamos y exclusiones antes de que envíes nada." },
          { q: "¿Dónde leo los términos completos de garantía?", a: "En la página de Garantía y en los documentos de compra. Si algo no está claro, el soporte confirmará la política que aplica a tu pedido específico." }
        ]
      },
      {
        name: "Soporte / mantenimiento",
        icon: "Wrench",
        subtitle: "Cómo contactar al soporte técnico y qué enviar para agilizar la respuesta.",
        faqs: [
          { q: "¿Cómo contacto al soporte?", a: "Usá el centro de soporte, el formulario o el canal indicado para tu caso. Para problemas urgentes el día del ride, enviá el número de serie, un resumen breve y fotos o video si es posible." },
          { q: "¿Qué mantenimiento necesita el equipo?", a: "El cuidado de rutina es simple: enjuagá después del uso, inspeccioná visualmente, almacená correctamente y prestá atención a las piezas y baterías. Pedí orientación antes de intentar reparaciones por tu cuenta." }
        ]
      },
      {
        name: "Pago / entrega",
        icon: "CreditCard",
        subtitle: "Plazos, confirmación y qué hacer después del pedido.",
        faqs: [
          { q: "¿Cómo funcionan el pago y la entrega?", a: "Los plazos y la logística se confirman después del pedido ya que dependen de la configuración, stock y destino. Siempre validá tu región con el equipo antes de la compra." },
          { q: "¿Envían fuera de Brasil?", a: "La disponibilidad depende del producto, destino y logística actual. La página de contacto o el soporte puede confirmar la respuesta correcta para tu pedido." }
        ]
      }
    ]
  }
};

export const getFaqData = (locale) => {
  return FAQ_CONTENT[locale] || FAQ_CONTENT.en;
};
